<template>
  <main class="md:px-44 px-7">
    <section class="grid pt-9 pb-4 gap-16 content-start items-start w-full">
      <article class="grid gap-4 md:w-80 md:mx-auto justify-center">
        <div class="h-64 w-44 justify-self-center">
          <Vue3Lottie ref="lottie" :animationData="AutoCrossAnimation" :speed="1" :loop="true" />
        </div>
        <div class="grid gap-5 text-center">
          <p v-if="queryData.upi === 'true'" class="text-3xl font-blogger font-bold text-headingColor width17rem">UPI Mandate registration failed</p>
          <p v-else class="text-3xl font-blogger font-bold text-headingColor width17rem">eMandate registration failed</p>
          <p v-if="queryData.errorMessage" class="text-center text-headingColor font-myriad text-base width17rem">
            {{ queryData.errorMessage }}
          </p>
        </div>
      </article>
    </section>
    <!-- overLayGoBack -->
    <over-lay-go-back :starterOverLay="isOverLay" @on-click-back-prev="handleBackToPrev"/>
  </main>
</template>
<script>
import { mapGetters } from 'vuex';
import overLayGoBack from '../components/overLayGoBack.vue';
import AutoCrossAnimation from '../assets/animation/Auto-Cross-Animation.json';

export default {
  name: 'MandateFailed',
  components: { overLayGoBack },
  computed: {
    ...mapGetters([]),
  },
  mounted() {
    setTimeout(() => {
      this.isOverLay = true;
    }, 4000);
    this.$trackEvent(this.$mixpanelEvent.MANDATE_FAILED);
  },
  data() {
    return {
      isOverLay: undefined,
      AutoCrossAnimation,
      queryData: this.$route.query,
    };
  },
  watch: {
  },
  methods: {
    handleBackToPrev() {
      this.isOverLay = false;
      setTimeout(() => {
        this.isOverLay = true;
      }, 4000);
    }
  },
};
</script>
<style lang="scss" scoped>
.width17rem{
  width: 17rem;
}
</style>
